import { apiClient } from "../../base/ApiClient";

export const getMedicineReports = async (date_from, date_to, client_id) => {
  const params = new URLSearchParams();

  if (date_from) params.append("date_from", date_from);
  if (date_to) params.append("date_to", date_to);
  if (client_id) params.append("client_id", client_id);

  const response = await apiClient.get(
    `/services/medication-reports/?${params.toString()}`
  );
  return response.data;
};
